import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@profiles_listAdder/"

const addListItemObj = makePieActionObjs("post", "list_item")
const removeListItemObj = makePieActionObjs("delete", "list_item")
const getListsForResourceObj = makePieActionObjs("get", "lists_for_resource")

export const addListItem = prependAppName(appName, addListItemObj.pieDict)
export const removeListItem = prependAppName(appName, removeListItemObj.pieDict)
export const getListsForResource = prependAppName(appName, getListsForResourceObj.pieDict)
